import * as Ee from "react";
import w, { useRef as M, useCallback as k, useEffect as N, useState as I, useMemo as B, useContext as ht } from "react";
import { h as yt, i as le, j as bt, k as vt, g as V, l as Te, a as O, m as $t, n as de, o as se, p as mt, d as Pt, e as Kt, q as xt, r as St } from "./useLocalizedStringFormatter-BVBIfLvJ.mjs";
import { d as U, a as we, b as G, $ as H, f as Ce, e as fe } from "./mergeProps-F8wVfzJL.mjs";
function Et(r, e) {
  if (e.has(r))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Tt(r, e, t) {
  Et(r, e), e.set(r, t);
}
const wt = /* @__PURE__ */ new Set([
  "id"
]), Ct = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), Dt = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), Mt = /^(data-.*)$/;
function Bt(r, e = {}) {
  let { labelable: t, isLink: n, propNames: i } = e, s = {};
  for (const o in r) Object.prototype.hasOwnProperty.call(r, o) && (wt.has(o) || t && Ct.has(o) || n && Dt.has(o) || i != null && i.has(o) || Mt.test(o)) && (s[o] = r[o]);
  return s;
}
function W(r, e, t = !0) {
  var n, i;
  let { metaKey: s, ctrlKey: o, altKey: u, shiftKey: c } = e;
  yt() && (!((i = window.event) === null || i === void 0 || (n = i.type) === null || n === void 0) && n.startsWith("key")) && r.target === "_blank" && (le() ? s = !0 : o = !0);
  let f = bt() && le() && !vt() ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: s,
    ctrlKey: o,
    altKey: u,
    shiftKey: c
  }) : new MouseEvent("click", {
    metaKey: s,
    ctrlKey: o,
    altKey: u,
    shiftKey: c,
    bubbles: !0,
    cancelable: !0
  });
  W.isOpening = t, V(r), r.dispatchEvent(f), W.isOpening = !1;
}
W.isOpening = !1;
let z = /* @__PURE__ */ new Map(), oe = /* @__PURE__ */ new Set();
function ge() {
  if (typeof window > "u") return;
  function r(n) {
    return "propertyName" in n;
  }
  let e = (n) => {
    if (!r(n) || !n.target) return;
    let i = z.get(n.target);
    i || (i = /* @__PURE__ */ new Set(), z.set(n.target, i), n.target.addEventListener("transitioncancel", t, {
      once: !0
    })), i.add(n.propertyName);
  }, t = (n) => {
    if (!r(n) || !n.target) return;
    let i = z.get(n.target);
    if (i && (i.delete(n.propertyName), i.size === 0 && (n.target.removeEventListener("transitioncancel", t), z.delete(n.target)), z.size === 0)) {
      for (let s of oe) s();
      oe.clear();
    }
  };
  document.body.addEventListener("transitionrun", e), document.body.addEventListener("transitionend", t);
}
typeof document < "u" && (document.readyState !== "loading" ? ge() : document.addEventListener("DOMContentLoaded", ge));
function At(r) {
  requestAnimationFrame(() => {
    z.size === 0 ? r() : oe.add(r);
  });
}
function De() {
  let r = M(/* @__PURE__ */ new Map()), e = k((i, s, o, u) => {
    let c = u != null && u.once ? (...f) => {
      r.current.delete(o), o(...f);
    } : o;
    r.current.set(o, {
      type: s,
      eventTarget: i,
      fn: c,
      options: u
    }), i.addEventListener(s, o, u);
  }, []), t = k((i, s, o, u) => {
    var c;
    let f = ((c = r.current.get(o)) === null || c === void 0 ? void 0 : c.fn) || o;
    i.removeEventListener(s, f, u), r.current.delete(o);
  }, []), n = k(() => {
    r.current.forEach((i, s) => {
      t(i.eventTarget, i.type, s, i.options);
    });
  }, [
    t
  ]);
  return N(() => n, [
    n
  ]), {
    addGlobalListener: e,
    removeGlobalListener: t,
    removeAllGlobalListeners: n
  };
}
function It(r, e) {
  let { id: t, "aria-label": n, "aria-labelledby": i } = r;
  return t = U(t), i && n ? i = [
    .../* @__PURE__ */ new Set([
      t,
      ...i.trim().split(/\s+/)
    ])
  ].join(" ") : i && (i = i.trim().split(/\s+/).join(" ")), !n && !i && e && (n = e), {
    id: t,
    "aria-label": n,
    "aria-labelledby": i
  };
}
function Ft(r, e) {
  we(() => {
    if (r && r.ref && e)
      return r.ref.current = e.current, () => {
        r.ref && (r.ref.current = null);
      };
  });
}
function pe(r, e) {
  let t = window.getComputedStyle(r), n = /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
  return n && e && (n = r.scrollHeight !== r.clientHeight || r.scrollWidth !== r.clientWidth), n;
}
let kt = 0;
const Q = /* @__PURE__ */ new Map();
function Lt(r) {
  let [e, t] = I();
  return we(() => {
    if (!r) return;
    let n = Q.get(r);
    if (n)
      t(n.element.id);
    else {
      let i = `react-aria-description-${kt++}`;
      t(i);
      let s = document.createElement("div");
      s.id = i, s.style.display = "none", s.textContent = r, document.body.appendChild(s), n = {
        refCount: 0,
        element: s
      }, Q.set(r, n);
    }
    return n.refCount++, () => {
      n && --n.refCount === 0 && (n.element.remove(), Q.delete(r));
    };
  }, [
    r
  ]), {
    "aria-describedby": r ? e : void 0
  };
}
function ue(r, e, t) {
  let [n, i] = I(r || e), s = M(r !== void 0), o = r !== void 0;
  N(() => {
    let f = s.current;
    f !== o && console.warn(`WARN: A component changed from ${f ? "controlled" : "uncontrolled"} to ${o ? "controlled" : "uncontrolled"}.`), s.current = o;
  }, [
    o
  ]);
  let u = o ? r : n, c = k((f, ...h) => {
    let b = (y, ...p) => {
      t && (Object.is(u, y) || t(y, ...p)), o || (u = y);
    };
    typeof f == "function" ? (console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), i((p, ...E) => {
      let K = f(o ? u : p, ...E);
      return b(K, ...h), o ? p : K;
    })) : (o || i(f), b(f, ...h));
  }, [
    o,
    u,
    t
  ]);
  return [
    u,
    c
  ];
}
let j = "default", ae = "", J = /* @__PURE__ */ new WeakMap();
function he(r) {
  if (Te()) {
    if (j === "default") {
      const e = O(r);
      ae = e.documentElement.style.webkitUserSelect, e.documentElement.style.webkitUserSelect = "none";
    }
    j = "disabled";
  } else (r instanceof HTMLElement || r instanceof SVGElement) && (J.set(r, r.style.userSelect), r.style.userSelect = "none");
}
function X(r) {
  if (Te()) {
    if (j !== "disabled") return;
    j = "restoring", setTimeout(() => {
      At(() => {
        if (j === "restoring") {
          const e = O(r);
          e.documentElement.style.webkitUserSelect === "none" && (e.documentElement.style.webkitUserSelect = ae || ""), ae = "", j = "default";
        }
      });
    }, 300);
  } else if ((r instanceof HTMLElement || r instanceof SVGElement) && r && J.has(r)) {
    let e = J.get(r);
    r.style.userSelect === "none" && (r.style.userSelect = e), r.getAttribute("style") === "" && r.removeAttribute("style"), J.delete(r);
  }
}
const Me = w.createContext({
  register: () => {
  }
});
Me.displayName = "PressResponderContext";
function Ot(r, e) {
  return e.get ? e.get.call(r) : e.value;
}
function Be(r, e, t) {
  if (!e.has(r)) throw new TypeError("attempted to " + t + " private field on non-instance");
  return e.get(r);
}
function _t(r, e) {
  var t = Be(r, e, "get");
  return Ot(r, t);
}
function Rt(r, e, t) {
  if (e.set) e.set.call(r, t);
  else {
    if (!e.writable)
      throw new TypeError("attempted to set read only private field");
    e.value = t;
  }
}
function ye(r, e, t) {
  var n = Be(r, e, "set");
  return Rt(r, n, t), t;
}
function zt(r) {
  let e = ht(Me);
  if (e) {
    let { register: t, ...n } = e;
    r = H(n, r), t();
  }
  return Ft(e, r.ref), r;
}
var q = /* @__PURE__ */ new WeakMap();
class Z {
  continuePropagation() {
    ye(this, q, !1);
  }
  get shouldStopPropagation() {
    return _t(this, q);
  }
  constructor(e, t, n) {
    Tt(this, q, {
      writable: !0,
      value: void 0
    }), ye(this, q, !0), this.type = e, this.pointerType = t, this.target = n.currentTarget, this.shiftKey = n.shiftKey, this.metaKey = n.metaKey, this.ctrlKey = n.ctrlKey, this.altKey = n.altKey;
  }
}
const be = Symbol("linkClicked");
function jt(r) {
  let {
    onPress: e,
    onPressChange: t,
    onPressStart: n,
    onPressEnd: i,
    onPressUp: s,
    isDisabled: o,
    isPressed: u,
    preventFocusOnPress: c,
    shouldCancelOnPointerExit: f,
    allowTextSelectionOnPress: h,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: b,
    ...y
  } = zt(r), [p, E] = I(!1), K = M({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    ignoreClickAfterPress: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null
  }), { addGlobalListener: v, removeAllGlobalListeners: T } = De(), m = G((l, $) => {
    let C = K.current;
    if (o || C.didFirePressStart) return !1;
    let g = !0;
    if (C.isTriggeringEvent = !0, n) {
      let x = new Z("pressstart", $, l);
      n(x), g = x.shouldStopPropagation;
    }
    return t && t(!0), C.isTriggeringEvent = !1, C.didFirePressStart = !0, E(!0), g;
  }), P = G((l, $, C = !0) => {
    let g = K.current;
    if (!g.didFirePressStart) return !1;
    g.ignoreClickAfterPress = !0, g.didFirePressStart = !1, g.isTriggeringEvent = !0;
    let x = !0;
    if (i) {
      let a = new Z("pressend", $, l);
      i(a), x = a.shouldStopPropagation;
    }
    if (t && t(!1), E(!1), e && C && !o) {
      let a = new Z("press", $, l);
      e(a), x && (x = a.shouldStopPropagation);
    }
    return g.isTriggeringEvent = !1, x;
  }), F = G((l, $) => {
    let C = K.current;
    if (o) return !1;
    if (s) {
      C.isTriggeringEvent = !0;
      let g = new Z("pressup", $, l);
      return s(g), C.isTriggeringEvent = !1, g.shouldStopPropagation;
    }
    return !0;
  }), L = G((l) => {
    let $ = K.current;
    $.isPressed && $.target && ($.isOverTarget && $.pointerType != null && P(A($.target, l), $.pointerType, !1), $.isPressed = !1, $.isOverTarget = !1, $.activePointerId = null, $.pointerType = null, T(), h || X($.target));
  }), Y = G((l) => {
    f && L(l);
  }), pt = B(() => {
    let l = K.current, $ = {
      onKeyDown(g) {
        if (ee(g.nativeEvent, g.currentTarget) && g.currentTarget.contains(g.target)) {
          var x;
          $e(g.target, g.key) && g.preventDefault();
          let a = !0;
          if (!l.isPressed && !g.repeat) {
            l.target = g.currentTarget, l.isPressed = !0, a = m(g, "keyboard");
            let d = g.currentTarget, S = (_) => {
              ee(_, d) && !_.repeat && d.contains(_.target) && l.target && F(A(l.target, _), "keyboard");
            };
            v(O(g.currentTarget), "keyup", Ce(S, C), !0);
          }
          a && g.stopPropagation(), g.metaKey && le() && ((x = l.metaKeyEvents) === null || x === void 0 || x.set(g.key, g.nativeEvent));
        } else g.key === "Meta" && (l.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(g) {
        if (!(g && !g.currentTarget.contains(g.target)) && g && g.button === 0 && !l.isTriggeringEvent && !W.isOpening) {
          let x = !0;
          if (o && g.preventDefault(), !l.ignoreClickAfterPress && !l.ignoreEmulatedMouseEvents && !l.isPressed && (l.pointerType === "virtual" || de(g.nativeEvent))) {
            !o && !c && V(g.currentTarget);
            let a = m(g, "virtual"), d = F(g, "virtual"), S = P(g, "virtual");
            x = a && d && S;
          }
          l.ignoreEmulatedMouseEvents = !1, l.ignoreClickAfterPress = !1, x && g.stopPropagation();
        }
      }
    }, C = (g) => {
      var x;
      if (l.isPressed && l.target && ee(g, l.target)) {
        var a;
        $e(g.target, g.key) && g.preventDefault();
        let S = g.target;
        P(A(l.target, g), "keyboard", l.target.contains(S)), T(), g.key !== "Enter" && ce(l.target) && l.target.contains(S) && !g[be] && (g[be] = !0, W(l.target, g, !1)), l.isPressed = !1, (a = l.metaKeyEvents) === null || a === void 0 || a.delete(g.key);
      } else if (g.key === "Meta" && (!((x = l.metaKeyEvents) === null || x === void 0) && x.size)) {
        var d;
        let S = l.metaKeyEvents;
        l.metaKeyEvents = void 0;
        for (let _ of S.values()) (d = l.target) === null || d === void 0 || d.dispatchEvent(new KeyboardEvent("keyup", _));
      }
    };
    if (typeof PointerEvent < "u") {
      $.onPointerDown = (d) => {
        if (d.button !== 0 || !d.currentTarget.contains(d.target)) return;
        if ($t(d.nativeEvent)) {
          l.pointerType = "virtual";
          return;
        }
        te(d.currentTarget) && d.preventDefault(), l.pointerType = d.pointerType;
        let S = !0;
        l.isPressed || (l.isPressed = !0, l.isOverTarget = !0, l.activePointerId = d.pointerId, l.target = d.currentTarget, !o && !c && V(d.currentTarget), h || he(l.target), S = m(d, l.pointerType), v(O(d.currentTarget), "pointermove", g, !1), v(O(d.currentTarget), "pointerup", x, !1), v(O(d.currentTarget), "pointercancel", a, !1)), S && d.stopPropagation();
      }, $.onMouseDown = (d) => {
        d.currentTarget.contains(d.target) && d.button === 0 && (te(d.currentTarget) && d.preventDefault(), d.stopPropagation());
      }, $.onPointerUp = (d) => {
        !d.currentTarget.contains(d.target) || l.pointerType === "virtual" || d.button === 0 && R(d, d.currentTarget) && F(d, l.pointerType || d.pointerType);
      };
      let g = (d) => {
        d.pointerId === l.activePointerId && (l.target && R(d, l.target) ? !l.isOverTarget && l.pointerType != null && (l.isOverTarget = !0, m(A(l.target, d), l.pointerType)) : l.target && l.isOverTarget && l.pointerType != null && (l.isOverTarget = !1, P(A(l.target, d), l.pointerType, !1), Y(d)));
      }, x = (d) => {
        d.pointerId === l.activePointerId && l.isPressed && d.button === 0 && l.target && (R(d, l.target) && l.pointerType != null ? P(A(l.target, d), l.pointerType) : l.isOverTarget && l.pointerType != null && P(A(l.target, d), l.pointerType, !1), l.isPressed = !1, l.isOverTarget = !1, l.activePointerId = null, l.pointerType = null, T(), h || X(l.target));
      }, a = (d) => {
        L(d);
      };
      $.onDragStart = (d) => {
        d.currentTarget.contains(d.target) && L(d);
      };
    } else {
      $.onMouseDown = (a) => {
        if (a.button !== 0 || !a.currentTarget.contains(a.target)) return;
        if (te(a.currentTarget) && a.preventDefault(), l.ignoreEmulatedMouseEvents) {
          a.stopPropagation();
          return;
        }
        l.isPressed = !0, l.isOverTarget = !0, l.target = a.currentTarget, l.pointerType = de(a.nativeEvent) ? "virtual" : "mouse", !o && !c && V(a.currentTarget), m(a, l.pointerType) && a.stopPropagation(), v(O(a.currentTarget), "mouseup", g, !1);
      }, $.onMouseEnter = (a) => {
        if (!a.currentTarget.contains(a.target)) return;
        let d = !0;
        l.isPressed && !l.ignoreEmulatedMouseEvents && l.pointerType != null && (l.isOverTarget = !0, d = m(a, l.pointerType)), d && a.stopPropagation();
      }, $.onMouseLeave = (a) => {
        if (!a.currentTarget.contains(a.target)) return;
        let d = !0;
        l.isPressed && !l.ignoreEmulatedMouseEvents && l.pointerType != null && (l.isOverTarget = !1, d = P(a, l.pointerType, !1), Y(a)), d && a.stopPropagation();
      }, $.onMouseUp = (a) => {
        a.currentTarget.contains(a.target) && !l.ignoreEmulatedMouseEvents && a.button === 0 && F(a, l.pointerType || "mouse");
      };
      let g = (a) => {
        if (a.button === 0) {
          if (l.isPressed = !1, T(), l.ignoreEmulatedMouseEvents) {
            l.ignoreEmulatedMouseEvents = !1;
            return;
          }
          l.target && R(a, l.target) && l.pointerType != null ? P(A(l.target, a), l.pointerType) : l.target && l.isOverTarget && l.pointerType != null && P(A(l.target, a), l.pointerType, !1), l.isOverTarget = !1;
        }
      };
      $.onTouchStart = (a) => {
        if (!a.currentTarget.contains(a.target)) return;
        let d = Ut(a.nativeEvent);
        if (!d) return;
        l.activePointerId = d.identifier, l.ignoreEmulatedMouseEvents = !0, l.isOverTarget = !0, l.isPressed = !0, l.target = a.currentTarget, l.pointerType = "touch", !o && !c && V(a.currentTarget), h || he(l.target), m(a, l.pointerType) && a.stopPropagation(), v(se(a.currentTarget), "scroll", x, !0);
      }, $.onTouchMove = (a) => {
        if (!a.currentTarget.contains(a.target)) return;
        if (!l.isPressed) {
          a.stopPropagation();
          return;
        }
        let d = ve(a.nativeEvent, l.activePointerId), S = !0;
        d && R(d, a.currentTarget) ? !l.isOverTarget && l.pointerType != null && (l.isOverTarget = !0, S = m(a, l.pointerType)) : l.isOverTarget && l.pointerType != null && (l.isOverTarget = !1, S = P(a, l.pointerType, !1), Y(a)), S && a.stopPropagation();
      }, $.onTouchEnd = (a) => {
        if (!a.currentTarget.contains(a.target)) return;
        if (!l.isPressed) {
          a.stopPropagation();
          return;
        }
        let d = ve(a.nativeEvent, l.activePointerId), S = !0;
        d && R(d, a.currentTarget) && l.pointerType != null ? (F(a, l.pointerType), S = P(a, l.pointerType)) : l.isOverTarget && l.pointerType != null && (S = P(a, l.pointerType, !1)), S && a.stopPropagation(), l.isPressed = !1, l.activePointerId = null, l.isOverTarget = !1, l.ignoreEmulatedMouseEvents = !0, l.target && !h && X(l.target), T();
      }, $.onTouchCancel = (a) => {
        a.currentTarget.contains(a.target) && (a.stopPropagation(), l.isPressed && L(a));
      };
      let x = (a) => {
        l.isPressed && a.target.contains(l.target) && L({
          currentTarget: l.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      $.onDragStart = (a) => {
        a.currentTarget.contains(a.target) && L(a);
      };
    }
    return $;
  }, [
    v,
    o,
    c,
    T,
    h,
    L,
    Y,
    P,
    m,
    F
  ]);
  return N(() => () => {
    var l;
    h || X((l = K.current.target) !== null && l !== void 0 ? l : void 0);
  }, [
    h
  ]), {
    isPressed: u || p,
    pressProps: H(y, pt)
  };
}
function ce(r) {
  return r.tagName === "A" && r.hasAttribute("href");
}
function ee(r, e) {
  const { key: t, code: n } = r, i = e, s = i.getAttribute("role");
  return (t === "Enter" || t === " " || t === "Spacebar" || n === "Space") && !(i instanceof se(i).HTMLInputElement && !Ae(i, t) || i instanceof se(i).HTMLTextAreaElement || i.isContentEditable) && // Links should only trigger with Enter key
  !((s === "link" || !s && ce(i)) && t !== "Enter");
}
function Ut(r) {
  const { targetTouches: e } = r;
  return e.length > 0 ? e[0] : null;
}
function ve(r, e) {
  const t = r.changedTouches;
  for (let n = 0; n < t.length; n++) {
    const i = t[n];
    if (i.identifier === e) return i;
  }
  return null;
}
function A(r, e) {
  return {
    currentTarget: r,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey
  };
}
function Ht(r) {
  let e = 0, t = 0;
  return r.width !== void 0 ? e = r.width / 2 : r.radiusX !== void 0 && (e = r.radiusX), r.height !== void 0 ? t = r.height / 2 : r.radiusY !== void 0 && (t = r.radiusY), {
    top: r.clientY - t,
    right: r.clientX + e,
    bottom: r.clientY + t,
    left: r.clientX - e
  };
}
function Nt(r, e) {
  return !(r.left > e.right || e.left > r.right || r.top > e.bottom || e.top > r.bottom);
}
function R(r, e) {
  let t = e.getBoundingClientRect(), n = Ht(r);
  return Nt(t, n);
}
function te(r) {
  return !(r instanceof HTMLElement) || !r.hasAttribute("draggable");
}
function $e(r, e) {
  return r instanceof HTMLInputElement ? !Ae(r, e) : r instanceof HTMLButtonElement ? r.type !== "submit" && r.type !== "reset" : !ce(r);
}
const Gt = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Ae(r, e) {
  return r.type === "checkbox" || r.type === "radio" ? e === " " : Gt.has(r.type);
}
const Vt = 500;
function Wt(r) {
  let { isDisabled: e, onLongPressStart: t, onLongPressEnd: n, onLongPress: i, threshold: s = Vt, accessibilityDescription: o } = r;
  const u = M();
  let { addGlobalListener: c, removeGlobalListener: f } = De(), { pressProps: h } = jt({
    isDisabled: e,
    onPressStart(y) {
      if (y.continuePropagation(), (y.pointerType === "mouse" || y.pointerType === "touch") && (t && t({
        ...y,
        type: "longpressstart"
      }), u.current = setTimeout(() => {
        y.target.dispatchEvent(new PointerEvent("pointercancel", {
          bubbles: !0
        })), i && i({
          ...y,
          type: "longpress"
        }), u.current = void 0;
      }, s), y.pointerType === "touch")) {
        let p = (E) => {
          E.preventDefault();
        };
        c(y.target, "contextmenu", p, {
          once: !0
        }), c(window, "pointerup", () => {
          setTimeout(() => {
            f(y.target, "contextmenu", p);
          }, 30);
        }, {
          once: !0
        });
      }
    },
    onPressEnd(y) {
      u.current && clearTimeout(u.current), n && (y.pointerType === "mouse" || y.pointerType === "touch") && n({
        ...y,
        type: "longpressend"
      });
    }
  }), b = Lt(i && !e ? o : void 0);
  return {
    longPressProps: H(h, b)
  };
}
let re = /* @__PURE__ */ new Map();
function Yt(r) {
  let { locale: e } = mt(), t = e + (r ? Object.entries(r).sort((i, s) => i[0] < s[0] ? -1 : 1).join() : "");
  if (re.has(t)) return re.get(t);
  let n = new Intl.Collator(e, r);
  return re.set(t, n), n;
}
function Xt(r) {
  let { id: e, label: t, "aria-labelledby": n, "aria-label": i, labelElementType: s = "label" } = r;
  e = U(e);
  let o = U(), u = {};
  t ? (n = n ? `${o} ${n}` : o, u = {
    id: o,
    htmlFor: s === "label" ? e : void 0
  }) : !n && !i && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let c = It({
    id: e,
    "aria-label": i,
    "aria-labelledby": n
  });
  return {
    labelProps: u,
    fieldProps: c
  };
}
function qt(r) {
  let { description: e, errorMessage: t, isInvalid: n, validationState: i } = r, { labelProps: s, fieldProps: o } = Xt(r), u = fe([
    !!e,
    !!t,
    n,
    i
  ]), c = fe([
    !!e,
    !!t,
    n,
    i
  ]);
  return o = H(o, {
    "aria-describedby": [
      u,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      c,
      r["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: s,
    fieldProps: o,
    descriptionProps: {
      id: u
    },
    errorMessageProps: {
      id: c
    }
  };
}
const Zt = /* @__PURE__ */ new WeakMap();
function Jt(r, e, t) {
  let { type: n } = r, { isOpen: i } = e;
  N(() => {
    t && t.current && Zt.set(t.current, e.close);
  });
  let s;
  n === "menu" ? s = !0 : n === "listbox" && (s = "listbox");
  let o = U();
  return {
    triggerProps: {
      "aria-haspopup": s,
      "aria-expanded": i,
      "aria-controls": i ? o : null,
      onPress: e.toggle
    },
    overlayProps: {
      id: o
    }
  };
}
const me = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function Qt(r = {}) {
  let { style: e, isFocusable: t } = r, [n, i] = I(!1), { focusWithinProps: s } = Pt({
    isDisabled: !t,
    onFocusWithinChange: (u) => i(u)
  }), o = B(() => n ? e : e ? {
    ...me,
    ...e
  } : me, [
    n
  ]);
  return {
    visuallyHiddenProps: {
      ...s,
      style: o
    }
  };
}
const er = 1e3;
function tr(r) {
  let { keyboardDelegate: e, selectionManager: t, onTypeSelect: n } = r, i = M({
    search: "",
    timeout: null
  }).current, s = (o) => {
    let u = rr(o.key);
    if (!u || o.ctrlKey || o.metaKey || !o.currentTarget.contains(o.target)) return;
    u === " " && i.search.trim().length > 0 && (o.preventDefault(), "continuePropagation" in o || o.stopPropagation()), i.search += u;
    let c = e.getKeyForSearch(i.search, t.focusedKey);
    c == null && (c = e.getKeyForSearch(i.search)), c != null && (t.setFocusedKey(c), n && n(c)), clearTimeout(i.timeout), i.timeout = setTimeout(() => {
      i.search = "";
    }, er);
  };
  return {
    typeSelectProps: {
      // Using a capturing listener to catch the keydown event before
      // other hooks in order to handle the Spacebar event.
      onKeyDownCapture: e.getKeyForSearch ? s : null
    }
  };
}
function rr(r) {
  return r.length === 1 || !/^[A-Z]/i.test(r) ? r : "";
}
class nr {
  isDisabled(e) {
    var t;
    return this.disabledBehavior === "all" && (((t = e.props) === null || t === void 0 ? void 0 : t.isDisabled) || this.disabledKeys.has(e.key));
  }
  getNextKey(e) {
    for (e = this.collection.getKeyAfter(e); e != null; ) {
      let t = this.collection.getItem(e);
      if (t.type === "item" && !this.isDisabled(t)) return e;
      e = this.collection.getKeyAfter(e);
    }
    return null;
  }
  getPreviousKey(e) {
    for (e = this.collection.getKeyBefore(e); e != null; ) {
      let t = this.collection.getItem(e);
      if (t.type === "item" && !this.isDisabled(t)) return e;
      e = this.collection.getKeyBefore(e);
    }
    return null;
  }
  findKey(e, t, n) {
    let i = this.getItem(e);
    if (!i) return null;
    let s = i.getBoundingClientRect();
    do
      e = t(e), i = this.getItem(e);
    while (i && n(s, i.getBoundingClientRect()));
    return e;
  }
  isSameRow(e, t) {
    return e.top === t.top || e.left !== t.left;
  }
  isSameColumn(e, t) {
    return e.left === t.left || e.top !== t.top;
  }
  getKeyBelow(e) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(e, (t) => this.getNextKey(t), this.isSameRow) : this.getNextKey(e);
  }
  getKeyAbove(e) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(e, (t) => this.getPreviousKey(t), this.isSameRow) : this.getPreviousKey(e);
  }
  getNextColumn(e, t) {
    return t ? this.getPreviousKey(e) : this.getNextKey(e);
  }
  getKeyRightOf(e) {
    return this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(e, this.direction === "rtl") : this.findKey(e, (t) => this.getNextColumn(t, this.direction === "rtl"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(e, this.direction === "rtl") : null;
  }
  getKeyLeftOf(e) {
    return this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(e, this.direction === "ltr") : this.findKey(e, (t) => this.getNextColumn(t, this.direction === "ltr"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(e, this.direction === "ltr") : null;
  }
  getFirstKey() {
    let e = this.collection.getFirstKey();
    for (; e != null; ) {
      let t = this.collection.getItem(e);
      if ((t == null ? void 0 : t.type) === "item" && !this.isDisabled(t)) return e;
      e = this.collection.getKeyAfter(e);
    }
    return null;
  }
  getLastKey() {
    let e = this.collection.getLastKey();
    for (; e != null; ) {
      let t = this.collection.getItem(e);
      if (t.type === "item" && !this.isDisabled(t)) return e;
      e = this.collection.getKeyBefore(e);
    }
    return null;
  }
  getItem(e) {
    return e !== null ? this.ref.current.querySelector(`[data-key="${CSS.escape(e.toString())}"]`) : null;
  }
  getKeyPageAbove(e) {
    let t = this.ref.current, n = this.getItem(e);
    if (!n) return null;
    if (!pe(t)) return this.getFirstKey();
    let i = t.getBoundingClientRect(), s = n.getBoundingClientRect();
    if (this.orientation === "horizontal") {
      let o = i.x - t.scrollLeft, u = Math.max(0, s.x - o + s.width - i.width);
      for (; n && s.x - o > u; )
        e = this.getKeyAbove(e), n = e == null ? null : this.getItem(e), s = n == null ? void 0 : n.getBoundingClientRect();
    } else {
      let o = i.y - t.scrollTop, u = Math.max(0, s.y - o + s.height - i.height);
      for (; n && s.y - o > u; )
        e = this.getKeyAbove(e), n = e == null ? null : this.getItem(e), s = n == null ? void 0 : n.getBoundingClientRect();
    }
    return e ?? this.getFirstKey();
  }
  getKeyPageBelow(e) {
    let t = this.ref.current, n = this.getItem(e);
    if (!n) return null;
    if (!pe(t)) return this.getLastKey();
    let i = t.getBoundingClientRect(), s = n.getBoundingClientRect();
    if (this.orientation === "horizontal") {
      let o = i.x - t.scrollLeft, u = Math.min(t.scrollWidth, s.x - o - s.width + i.width);
      for (; n && s.x - o < u; )
        e = this.getKeyBelow(e), n = e == null ? null : this.getItem(e), s = n == null ? void 0 : n.getBoundingClientRect();
    } else {
      let o = i.y - t.scrollTop, u = Math.min(t.scrollHeight, s.y - o - s.height + i.height);
      for (; n && s.y - o < u; )
        e = this.getKeyBelow(e), n = e == null ? null : this.getItem(e), s = n == null ? void 0 : n.getBoundingClientRect();
    }
    return e ?? this.getLastKey();
  }
  getKeyForSearch(e, t) {
    if (!this.collator) return null;
    let n = this.collection, i = t || this.getFirstKey();
    for (; i != null; ) {
      let s = n.getItem(i), o = s.textValue.slice(0, e.length);
      if (s.textValue && this.collator.compare(o, e) === 0) return i;
      i = this.getKeyBelow(i);
    }
    return null;
  }
  constructor(...e) {
    if (e.length === 1) {
      let t = e[0];
      this.collection = t.collection, this.ref = t.ref, this.collator = t.collator, this.disabledKeys = t.disabledKeys || /* @__PURE__ */ new Set(), this.disabledBehavior = t.disabledBehavior || "all", this.orientation = t.orientation, this.direction = t.direction, this.layout = t.layout || "stack";
    } else
      this.collection = e[0], this.disabledKeys = e[1], this.ref = e[2], this.collator = e[3], this.layout = "stack", this.orientation = "vertical", this.disabledBehavior = "all";
    this.layout === "stack" && this.orientation === "vertical" && (this.getKeyLeftOf = void 0, this.getKeyRightOf = void 0);
  }
}
class ir {
  build(e, t) {
    return this.context = t, Pe(() => this.iterateCollection(e));
  }
  *iterateCollection(e) {
    let { children: t, items: n } = e;
    if (typeof t == "function") {
      if (!n) throw new Error("props.children was a function but props.items is missing");
      for (let i of e.items) yield* this.getFullNode({
        value: i
      }, {
        renderer: t
      });
    } else {
      let i = [];
      w.Children.forEach(t, (o) => {
        i.push(o);
      });
      let s = 0;
      for (let o of i) {
        let u = this.getFullNode({
          element: o,
          index: s
        }, {});
        for (let c of u)
          s++, yield c;
      }
    }
  }
  getKey(e, t, n, i) {
    if (e.key != null) return e.key;
    if (t.type === "cell" && t.key != null) return `${i}${t.key}`;
    let s = t.value;
    if (s != null) {
      var o;
      let u = (o = s.key) !== null && o !== void 0 ? o : s.id;
      if (u == null) throw new Error("No key found for item");
      return u;
    }
    return i ? `${i}.${t.index}` : `$.${t.index}`;
  }
  getChildState(e, t) {
    return {
      renderer: t.renderer || e.renderer
    };
  }
  *getFullNode(e, t, n, i) {
    let s = e.element;
    if (!s && e.value && t && t.renderer) {
      let c = this.cache.get(e.value);
      if (c && (!c.shouldInvalidate || !c.shouldInvalidate(this.context))) {
        c.index = e.index, c.parentKey = i ? i.key : null, yield c;
        return;
      }
      s = t.renderer(e.value);
    }
    if (w.isValidElement(s)) {
      let c = s.type;
      if (typeof c != "function" && typeof c.getCollectionNode != "function") {
        let y = typeof s.type == "function" ? s.type.name : s.type;
        throw new Error(`Unknown element <${y}> in collection.`);
      }
      let f = c.getCollectionNode(s.props, this.context), h = e.index, b = f.next();
      for (; !b.done && b.value; ) {
        let y = b.value;
        e.index = h;
        let p = y.key;
        p || (p = y.element ? null : this.getKey(s, e, t, n));
        let K = [
          ...this.getFullNode({
            ...y,
            key: p,
            index: h,
            wrapper: lr(e.wrapper, y.wrapper)
          }, this.getChildState(t, y), n ? `${n}${s.key}` : s.key, i)
        ];
        for (let v of K) {
          if (v.value = y.value || e.value, v.value && this.cache.set(v.value, v), e.type && v.type !== e.type) throw new Error(`Unsupported type <${ne(v.type)}> in <${ne(i.type)}>. Only <${ne(e.type)}> is supported.`);
          h++, yield v;
        }
        b = f.next(K);
      }
      return;
    }
    if (e.key == null) return;
    let o = this, u = {
      type: e.type,
      props: e.props,
      key: e.key,
      parentKey: i ? i.key : null,
      value: e.value,
      level: i ? i.level + 1 : 0,
      index: e.index,
      rendered: e.rendered,
      textValue: e.textValue,
      "aria-label": e["aria-label"],
      wrapper: e.wrapper,
      shouldInvalidate: e.shouldInvalidate,
      hasChildNodes: e.hasChildNodes,
      childNodes: Pe(function* () {
        if (!e.hasChildNodes) return;
        let c = 0;
        for (let f of e.childNodes()) {
          f.key != null && (f.key = `${u.key}${f.key}`), f.index = c;
          let h = o.getFullNode(f, o.getChildState(t, f), u.key, u);
          for (let b of h)
            c++, yield b;
        }
      })
    };
    yield u;
  }
  constructor() {
    this.cache = /* @__PURE__ */ new WeakMap();
  }
}
function Pe(r) {
  let e = [], t = null;
  return {
    *[Symbol.iterator]() {
      for (let n of e) yield n;
      t || (t = r());
      for (let n of t)
        e.push(n), yield n;
    }
  };
}
function lr(r, e) {
  if (r && e) return (t) => r(e(t));
  if (r) return r;
  if (e) return e;
}
function ne(r) {
  return r[0].toUpperCase() + r.slice(1);
}
function sr(r, e, t) {
  let n = B(() => new ir(), []), { children: i, items: s, collection: o } = r;
  return B(() => {
    if (o) return o;
    let c = n.build({
      children: i,
      items: s
    }, t);
    return e(c);
  }, [
    n,
    i,
    s,
    o,
    t,
    e
  ]);
}
function or(r, e) {
  return typeof e.getChildren == "function" ? e.getChildren(r.key) : r.childNodes;
}
function ar(r) {
  return ur(r);
}
function ur(r, e) {
  for (let t of r)
    return t;
}
function ie(r, e, t) {
  if (e.parentKey === t.parentKey) return e.index - t.index;
  let n = [
    ...Ke(r, e),
    e
  ], i = [
    ...Ke(r, t),
    t
  ], s = n.slice(0, i.length).findIndex((o, u) => o !== i[u]);
  return s !== -1 ? (e = n[s], t = i[s], e.index - t.index) : n.findIndex((o) => o === t) >= 0 ? 1 : (i.findIndex((o) => o === e) >= 0, -1);
}
function Ke(r, e) {
  let t = [];
  for (; (e == null ? void 0 : e.parentKey) != null; )
    e = r.getItem(e.parentKey), t.unshift(e);
  return t;
}
var Ie = {};
Ie = {
  longPressMessage: "اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة"
};
var Fe = {};
Fe = {
  longPressMessage: "Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто"
};
var ke = {};
ke = {
  longPressMessage: "Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku"
};
var Le = {};
Le = {
  longPressMessage: "Langt tryk eller tryk på Alt + pil ned for at åbne menuen"
};
var Oe = {};
Oe = {
  longPressMessage: "Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen"
};
var _e = {};
_e = {
  longPressMessage: "Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού"
};
var Re = {};
Re = {
  longPressMessage: "Long press or press Alt + ArrowDown to open menu"
};
var ze = {};
ze = {
  longPressMessage: "Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú"
};
var je = {};
je = {
  longPressMessage: "Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool"
};
var Ue = {};
Ue = {
  longPressMessage: "Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli"
};
var He = {};
He = {
  longPressMessage: "Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu."
};
var Ne = {};
Ne = {
  longPressMessage: "לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט"
};
var Ge = {};
Ge = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika"
};
var Ve = {};
Ve = {
  longPressMessage: "Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához"
};
var We = {};
We = {
  longPressMessage: "Premere a lungo o premere Alt + Freccia giù per aprire il menu"
};
var Ye = {};
Ye = {
  longPressMessage: "長押しまたは Alt+下矢印キーでメニューを開く"
};
var Xe = {};
Xe = {
  longPressMessage: "길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기"
};
var qe = {};
qe = {
  longPressMessage: "Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“."
};
var Ze = {};
Ze = {
  longPressMessage: "Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa"
};
var Je = {};
Je = {
  longPressMessage: "Langt trykk eller trykk Alt + PilNed for å åpne menyen"
};
var Qe = {};
Qe = {
  longPressMessage: "Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen"
};
var et = {};
et = {
  longPressMessage: "Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu"
};
var tt = {};
tt = {
  longPressMessage: "Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu"
};
var rt = {};
rt = {
  longPressMessage: "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
};
var nt = {};
nt = {
  longPressMessage: "Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul"
};
var it = {};
it = {
  longPressMessage: "Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню"
};
var lt = {};
lt = {
  longPressMessage: "Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol"
};
var st = {};
st = {
  longPressMessage: "Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol"
};
var ot = {};
ot = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"
};
var at = {};
at = {
  longPressMessage: "Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn"
};
var ut = {};
ut = {
  longPressMessage: "Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın"
};
var ct = {};
ct = {
  longPressMessage: "Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню"
};
var dt = {};
dt = {
  longPressMessage: "长按或按 Alt + 向下方向键以打开菜单"
};
var ft = {};
ft = {
  longPressMessage: "長按或按 Alt+向下鍵以開啟功能表"
};
var gt = {};
gt = {
  "ar-AE": Ie,
  "bg-BG": Fe,
  "cs-CZ": ke,
  "da-DK": Le,
  "de-DE": Oe,
  "el-GR": _e,
  "en-US": Re,
  "es-ES": ze,
  "et-EE": je,
  "fi-FI": Ue,
  "fr-FR": He,
  "he-IL": Ne,
  "hr-HR": Ge,
  "hu-HU": Ve,
  "it-IT": We,
  "ja-JP": Ye,
  "ko-KR": Xe,
  "lt-LT": qe,
  "lv-LV": Ze,
  "nb-NO": Je,
  "nl-NL": Qe,
  "pl-PL": et,
  "pt-BR": tt,
  "pt-PT": rt,
  "ro-RO": nt,
  "ru-RU": it,
  "sk-SK": lt,
  "sl-SI": st,
  "sr-SP": ot,
  "sv-SE": at,
  "tr-TR": ut,
  "uk-UA": ct,
  "zh-CN": dt,
  "zh-TW": ft
};
function cr(r) {
  return r && r.__esModule ? r.default : r;
}
function dr(r, e, t) {
  let { type: n = "menu", isDisabled: i, trigger: s = "press" } = r, o = U(), { triggerProps: u, overlayProps: c } = Jt({
    type: n
  }, e, t), f = (p) => {
    if (!i && !(s === "longPress" && !p.altKey) && t && t.current)
      switch (p.key) {
        case "Enter":
        case " ":
          if (s === "longPress") return;
        case "ArrowDown":
          "continuePropagation" in p || p.stopPropagation(), p.preventDefault(), e.toggle("first");
          break;
        case "ArrowUp":
          "continuePropagation" in p || p.stopPropagation(), p.preventDefault(), e.toggle("last");
          break;
        default:
          "continuePropagation" in p && p.continuePropagation();
      }
  }, h = Kt(cr(gt), "@react-aria/menu"), { longPressProps: b } = Wt({
    isDisabled: i || s !== "longPress",
    accessibilityDescription: h.format("longPressMessage"),
    onLongPressStart() {
      e.close();
    },
    onLongPress() {
      e.open("first");
    }
  }), y = {
    onPressStart(p) {
      p.pointerType !== "touch" && p.pointerType !== "keyboard" && !i && e.open(p.pointerType === "virtual" ? "first" : null);
    },
    onPress(p) {
      p.pointerType === "touch" && !i && e.toggle();
    }
  };
  return delete u.onPress, {
    menuTriggerProps: {
      ...u,
      ...s === "press" ? y : b,
      id: o,
      onKeyDown: f
    },
    menuProps: {
      ...c,
      "aria-labelledby": o,
      autoFocus: e.focusStrategy || !0,
      onClose: e.close
    }
  };
}
class xe {
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(e) {
    let t = this.keyMap.get(e);
    return t ? t.prevKey : null;
  }
  getKeyAfter(e) {
    let t = this.keyMap.get(e);
    return t ? t.nextKey : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(e) {
    return this.keyMap.get(e);
  }
  at(e) {
    const t = [
      ...this.getKeys()
    ];
    return this.getItem(t[e]);
  }
  getChildren(e) {
    let t = this.keyMap.get(e);
    return (t == null ? void 0 : t.childNodes) || [];
  }
  constructor(e) {
    this.keyMap = /* @__PURE__ */ new Map(), this.iterable = e;
    let t = (s) => {
      if (this.keyMap.set(s.key, s), s.childNodes && s.type === "section") for (let o of s.childNodes) t(o);
    };
    for (let s of e) t(s);
    let n, i = 0;
    for (let [s, o] of this.keyMap)
      n ? (n.nextKey = s, o.prevKey = n.key) : (this.firstKey = s, o.prevKey = void 0), o.type === "item" && (o.index = i++), n = o, n.nextKey = void 0;
    this.lastKey = n == null ? void 0 : n.key;
  }
}
class D extends Set {
  constructor(e, t, n) {
    super(e), e instanceof D ? (this.anchorKey = t || e.anchorKey, this.currentKey = n || e.currentKey) : (this.anchorKey = t, this.currentKey = n);
  }
}
function fr(r, e) {
  if (r.size !== e.size) return !1;
  for (let t of r)
    if (!e.has(t)) return !1;
  return !0;
}
function gr(r) {
  let { selectionMode: e = "none", disallowEmptySelection: t, allowDuplicateSelectionEvents: n, selectionBehavior: i = "toggle", disabledBehavior: s = "all" } = r, o = M(!1), [, u] = I(!1), c = M(null), f = M(null), [, h] = I(null), b = B(() => Se(r.selectedKeys), [
    r.selectedKeys
  ]), y = B(() => Se(r.defaultSelectedKeys, new D()), [
    r.defaultSelectedKeys
  ]), [p, E] = ue(b, y, r.onSelectionChange), K = B(() => r.disabledKeys ? new Set(r.disabledKeys) : /* @__PURE__ */ new Set(), [
    r.disabledKeys
  ]), [v, T] = I(i);
  i === "replace" && v === "toggle" && typeof p == "object" && p.size === 0 && T("replace");
  let m = M(i);
  return N(() => {
    i !== m.current && (T(i), m.current = i);
  }, [
    i
  ]), {
    selectionMode: e,
    disallowEmptySelection: t,
    selectionBehavior: v,
    setSelectionBehavior: T,
    get isFocused() {
      return o.current;
    },
    setFocused(P) {
      o.current = P, u(P);
    },
    get focusedKey() {
      return c.current;
    },
    get childFocusStrategy() {
      return f.current;
    },
    setFocusedKey(P, F = "first") {
      c.current = P, f.current = F, h(P);
    },
    selectedKeys: p,
    setSelectedKeys(P) {
      (n || !fr(P, p)) && E(P);
    },
    disabledKeys: K,
    disabledBehavior: s
  };
}
function Se(r, e) {
  return r ? r === "all" ? "all" : new D(r) : e;
}
class pr {
  /**
  * The type of selection that is allowed in the collection.
  */
  get selectionMode() {
    return this.state.selectionMode;
  }
  /**
  * Whether the collection allows empty selection.
  */
  get disallowEmptySelection() {
    return this.state.disallowEmptySelection;
  }
  /**
  * The selection behavior for the collection.
  */
  get selectionBehavior() {
    return this.state.selectionBehavior;
  }
  /**
  * Sets the selection behavior for the collection.
  */
  setSelectionBehavior(e) {
    this.state.setSelectionBehavior(e);
  }
  /**
  * Whether the collection is currently focused.
  */
  get isFocused() {
    return this.state.isFocused;
  }
  /**
  * Sets whether the collection is focused.
  */
  setFocused(e) {
    this.state.setFocused(e);
  }
  /**
  * The current focused key in the collection.
  */
  get focusedKey() {
    return this.state.focusedKey;
  }
  /** Whether the first or last child of the focused key should receive focus. */
  get childFocusStrategy() {
    return this.state.childFocusStrategy;
  }
  /**
  * Sets the focused key.
  */
  setFocusedKey(e, t) {
    (e == null || this.collection.getItem(e)) && this.state.setFocusedKey(e, t);
  }
  /**
  * The currently selected keys in the collection.
  */
  get selectedKeys() {
    return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
  }
  /**
  * The raw selection value for the collection.
  * Either 'all' for select all, or a set of keys.
  */
  get rawSelection() {
    return this.state.selectedKeys;
  }
  /**
  * Returns whether a key is selected.
  */
  isSelected(e) {
    return this.state.selectionMode === "none" ? !1 : (e = this.getKey(e), this.state.selectedKeys === "all" ? this.canSelectItem(e) : this.state.selectedKeys.has(e));
  }
  /**
  * Whether the selection is empty.
  */
  get isEmpty() {
    return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
  }
  /**
  * Whether all items in the collection are selected.
  */
  get isSelectAll() {
    if (this.isEmpty) return !1;
    if (this.state.selectedKeys === "all") return !0;
    if (this._isSelectAll != null) return this._isSelectAll;
    let e = this.getSelectAllKeys(), t = this.state.selectedKeys;
    return this._isSelectAll = e.every((n) => t.has(n)), this._isSelectAll;
  }
  get firstSelectedKey() {
    let e = null;
    for (let t of this.state.selectedKeys) {
      let n = this.collection.getItem(t);
      (!e || n && ie(this.collection, n, e) < 0) && (e = n);
    }
    return e == null ? void 0 : e.key;
  }
  get lastSelectedKey() {
    let e = null;
    for (let t of this.state.selectedKeys) {
      let n = this.collection.getItem(t);
      (!e || n && ie(this.collection, n, e) > 0) && (e = n);
    }
    return e == null ? void 0 : e.key;
  }
  get disabledKeys() {
    return this.state.disabledKeys;
  }
  get disabledBehavior() {
    return this.state.disabledBehavior;
  }
  /**
  * Extends the selection to the given key.
  */
  extendSelection(e) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single") {
      this.replaceSelection(e);
      return;
    }
    e = this.getKey(e);
    let t;
    if (this.state.selectedKeys === "all") t = new D([
      e
    ], e, e);
    else {
      let n = this.state.selectedKeys, i = n.anchorKey || e;
      t = new D(n, i, e);
      for (let s of this.getKeyRange(i, n.currentKey || e)) t.delete(s);
      for (let s of this.getKeyRange(e, i)) this.canSelectItem(s) && t.add(s);
    }
    this.state.setSelectedKeys(t);
  }
  getKeyRange(e, t) {
    let n = this.collection.getItem(e), i = this.collection.getItem(t);
    return n && i ? ie(this.collection, n, i) <= 0 ? this.getKeyRangeInternal(e, t) : this.getKeyRangeInternal(t, e) : [];
  }
  getKeyRangeInternal(e, t) {
    let n = [], i = e;
    for (; i; ) {
      let s = this.collection.getItem(i);
      if ((s && s.type === "item" || s.type === "cell" && this.allowsCellSelection) && n.push(i), i === t) return n;
      i = this.collection.getKeyAfter(i);
    }
    return [];
  }
  getKey(e) {
    let t = this.collection.getItem(e);
    if (!t || t.type === "cell" && this.allowsCellSelection) return e;
    for (; t.type !== "item" && t.parentKey != null; ) t = this.collection.getItem(t.parentKey);
    return !t || t.type !== "item" ? null : t.key;
  }
  /**
  * Toggles whether the given key is selected.
  */
  toggleSelection(e) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single" && !this.isSelected(e)) {
      this.replaceSelection(e);
      return;
    }
    if (e = this.getKey(e), e == null) return;
    let t = new D(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
    t.has(e) ? t.delete(e) : this.canSelectItem(e) && (t.add(e), t.anchorKey = e, t.currentKey = e), !(this.disallowEmptySelection && t.size === 0) && this.state.setSelectedKeys(t);
  }
  /**
  * Replaces the selection with only the given key.
  */
  replaceSelection(e) {
    if (this.selectionMode === "none" || (e = this.getKey(e), e == null)) return;
    let t = this.canSelectItem(e) ? new D([
      e
    ], e, e) : new D();
    this.state.setSelectedKeys(t);
  }
  /**
  * Replaces the selection with the given keys.
  */
  setSelectedKeys(e) {
    if (this.selectionMode === "none") return;
    let t = new D();
    for (let n of e)
      if (n = this.getKey(n), n != null && (t.add(n), this.selectionMode === "single"))
        break;
    this.state.setSelectedKeys(t);
  }
  getSelectAllKeys() {
    let e = [], t = (n) => {
      for (; n; ) {
        if (this.canSelectItem(n)) {
          let i = this.collection.getItem(n);
          i.type === "item" && e.push(n), i.hasChildNodes && (this.allowsCellSelection || i.type !== "item") && t(ar(or(i, this.collection)).key);
        }
        n = this.collection.getKeyAfter(n);
      }
    };
    return t(this.collection.getFirstKey()), e;
  }
  /**
  * Selects all items in the collection.
  */
  selectAll() {
    !this.isSelectAll && this.selectionMode === "multiple" && this.state.setSelectedKeys("all");
  }
  /**
  * Removes all keys from the selection.
  */
  clearSelection() {
    !this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0) && this.state.setSelectedKeys(new D());
  }
  /**
  * Toggles between select all and an empty selection.
  */
  toggleSelectAll() {
    this.isSelectAll ? this.clearSelection() : this.selectAll();
  }
  select(e, t) {
    this.selectionMode !== "none" && (this.selectionMode === "single" ? this.isSelected(e) && !this.disallowEmptySelection ? this.toggleSelection(e) : this.replaceSelection(e) : this.selectionBehavior === "toggle" || t && (t.pointerType === "touch" || t.pointerType === "virtual") ? this.toggleSelection(e) : this.replaceSelection(e));
  }
  /**
  * Returns whether the current selection is equal to the given selection.
  */
  isSelectionEqual(e) {
    if (e === this.state.selectedKeys) return !0;
    let t = this.selectedKeys;
    if (e.size !== t.size) return !1;
    for (let n of e)
      if (!t.has(n)) return !1;
    for (let n of t)
      if (!e.has(n)) return !1;
    return !0;
  }
  canSelectItem(e) {
    var t;
    if (this.state.selectionMode === "none" || this.state.disabledKeys.has(e)) return !1;
    let n = this.collection.getItem(e);
    return !(!n || !(n == null || (t = n.props) === null || t === void 0) && t.isDisabled || n.type === "cell" && !this.allowsCellSelection);
  }
  isDisabled(e) {
    var t, n;
    return this.state.disabledBehavior === "all" && (this.state.disabledKeys.has(e) || !!(!((n = this.collection.getItem(e)) === null || n === void 0 || (t = n.props) === null || t === void 0) && t.isDisabled));
  }
  isLink(e) {
    var t, n;
    return !!(!((n = this.collection.getItem(e)) === null || n === void 0 || (t = n.props) === null || t === void 0) && t.href);
  }
  getItemProps(e) {
    var t;
    return (t = this.collection.getItem(e)) === null || t === void 0 ? void 0 : t.props;
  }
  constructor(e, t, n) {
    this.collection = e, this.state = t;
    var i;
    this.allowsCellSelection = (i = n == null ? void 0 : n.allowsCellSelection) !== null && i !== void 0 ? i : !1, this._isSelectAll = null;
  }
}
function hr(r) {
  let { filter: e } = r, t = gr(r), n = B(() => r.disabledKeys ? new Set(r.disabledKeys) : /* @__PURE__ */ new Set(), [
    r.disabledKeys
  ]), i = k((f) => e ? new xe(e(f)) : new xe(f), [
    e
  ]), s = B(() => ({
    suppressTextValueWarning: r.suppressTextValueWarning
  }), [
    r.suppressTextValueWarning
  ]), o = sr(r, i, s), u = B(() => new pr(o, t), [
    o,
    t
  ]);
  const c = M(null);
  return N(() => {
    if (t.focusedKey != null && !o.getItem(t.focusedKey)) {
      const f = c.current.getItem(t.focusedKey), h = [
        ...c.current.getKeys()
      ].map((K) => {
        const v = c.current.getItem(K);
        return v.type === "item" ? v : null;
      }).filter((K) => K !== null), b = [
        ...o.getKeys()
      ].map((K) => {
        const v = o.getItem(K);
        return v.type === "item" ? v : null;
      }).filter((K) => K !== null), y = h.length - b.length;
      let p = Math.min(y > 1 ? Math.max(f.index - y + 1, 0) : f.index, b.length - 1), E;
      for (; p >= 0; ) {
        if (!u.isDisabled(b[p].key)) {
          E = b[p];
          break;
        }
        p < b.length - 1 ? p++ : (p > f.index && (p = f.index), p--);
      }
      t.setFocusedKey(E ? E.key : null);
    }
    c.current = o;
  }, [
    o,
    u,
    t,
    t.focusedKey
  ]), {
    collection: o,
    disabledKeys: n,
    selectionManager: u
  };
}
function yr(r) {
  let [e, t] = ue(r.isOpen, r.defaultOpen || !1, r.onOpenChange);
  const n = k(() => {
    t(!0);
  }, [
    t
  ]), i = k(() => {
    t(!1);
  }, [
    t
  ]), s = k(() => {
    t(!e);
  }, [
    t,
    e
  ]);
  return {
    isOpen: e,
    setOpen: t,
    open: n,
    close: i,
    toggle: s
  };
}
function br(r) {
  let e = yr(r), [t, n] = I(null), [i, s] = I([]), o = () => {
    s([]), e.close();
  };
  return {
    focusStrategy: t,
    ...e,
    open(f = null) {
      n(f), e.open();
    },
    toggle(f = null) {
      n(f), e.toggle();
    },
    close() {
      o();
    },
    expandedKeysStack: i,
    openSubmenu: (f, h) => {
      s((b) => h > b.length ? b : [
        ...b.slice(0, h),
        f
      ]);
    },
    closeSubmenu: (f, h) => {
      s((b) => b[h] === f ? b.slice(0, h) : b);
    }
  };
}
/*!
  MIT License

  Copyright (c) 2021 project44, Inc.

  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
  associated documentation files (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge, publish, distribute,
  sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all copies or substantial
  portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
  NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES
  OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
function vr(r, e, t) {
  const { autoComplete: n, name: i, isDisabled: s } = r, o = xt(), { visuallyHiddenProps: u } = Qt();
  return {
    containerProps: {
      ...u,
      "aria-hidden": !0
    },
    inputProps: {
      type: "text",
      tabIndex: o == null || e.isFocused || e.isOpen ? -1 : 0,
      style: { fontSize: 16 },
      onFocus: () => {
        var c;
        return (c = t.current) == null ? void 0 : c.focus();
      },
      disabled: s
    },
    selectProps: {
      tabIndex: -1,
      autoComplete: n,
      disabled: s,
      name: i,
      size: e.collection.size,
      selectedoptions: [...e.collection].map((c) => c.key),
      onChange: (c) => void e.setSelectedKeys(
        new Set(
          [
            ...c.target.selectedOptions
          ].map((f) => f.value)
        )
      )
    }
  };
}
/*!
  MIT License

  Copyright (c) 2021 project44, Inc.

  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
  associated documentation files (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge, publish, distribute,
  sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all copies or substantial
  portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
  NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES
  OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
function $r(r) {
  const { state: e, triggerRef: t, label: n, name: i, isDisabled: s } = r, { containerProps: o, inputProps: u, selectProps: c } = vr(
    r,
    e,
    t
  );
  return e.collection.size <= 300 ? /* @__PURE__ */ w.createElement("div", { ...o }, /* @__PURE__ */ w.createElement("input", { ...u }), /* @__PURE__ */ w.createElement("label", null, n, /* @__PURE__ */ w.createElement("select", { multiple: !0, ...c }, /* @__PURE__ */ w.createElement("option", null), [...e.collection.getKeys()].map((f) => {
    const h = e.collection.getItem(f);
    return (h == null ? void 0 : h.type) === "item" ? /* @__PURE__ */ w.createElement("option", { key: h.key, value: h.key }, h.textValue) : null;
  })))) : i ? /* @__PURE__ */ w.createElement(w.Fragment, null, [...e.selectedKeys].map((f) => /* @__PURE__ */ w.createElement(
    "input",
    {
      key: f,
      multiple: !0,
      autoComplete: c.autoComplete,
      disabled: s,
      name: i,
      type: "hidden",
      value: f
    }
  ))) : null;
}
$r.displayName = "HiddenMultiSelect";
/*!
  MIT License

  Copyright (c) 2021 project44, Inc.

  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
  associated documentation files (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge, publish, distribute,
  sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all copies or substantial
  portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
  NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES
  OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
function Sr(r, e, t) {
  const { keyboardDelegate: n, isDisabled: i } = r, s = Yt({ usage: "search", sensitivity: "base" }), o = Ee.useMemo(
    () => n ?? new nr({
      collator: s,
      collection: e.collection,
      disabledKeys: e.disabledKeys,
      ref: null
    }),
    [n, e.collection, e.disabledKeys, s]
  ), { menuTriggerProps: u, menuProps: c } = dr(
    {
      isDisabled: i,
      type: "listbox"
    },
    e,
    t
  ), { typeSelectProps: f } = tr({
    keyboardDelegate: o,
    selectionManager: e.selectionManager,
    onTypeSelect: (m) => {
      e.selectedKeys === "all" ? e.setSelectedKeys(
        new Set(
          [...e.collection].map((P) => P.key).filter((P) => P !== m)
        )
      ) : e.setSelectedKeys(e.selectedKeys.add(m));
    }
  }), { labelProps: h, fieldProps: b, descriptionProps: y, errorMessageProps: p } = qt({
    ...r,
    labelElementType: "span"
  }), E = f.onKeyDownCapture;
  f.onKeyDown = (m) => {
    m.key !== "Escape" && (E == null || E(m));
  }, delete f.onKeyDownCapture;
  const K = Bt(r, { labelable: !0 }), v = H(
    f,
    u,
    b
  ), T = U();
  return {
    labelProps: {
      ...h,
      onClick: () => {
        var m;
        r.isDisabled || ((m = t.current) == null || m.focus(), St("keyboard"));
      }
    },
    triggerProps: H(K, {
      ...v,
      onKeyDown: Ce(v.onKeyDown, r.onKeyDown),
      onKeyUp: r.onKeyUp,
      "aria-labelledby": [
        v["aria-labelledby"],
        v["aria-label"] && !v["aria-labelledby"] ? v.id : null,
        T
      ].filter(Boolean).join(" "),
      onFocus(m) {
        e.isFocused || (r.onFocus && r.onFocus(m), r.onFocusChange && r.onFocusChange(!0), e.setFocused(!0));
      },
      onBlur(m) {
        e.isOpen || (r.onBlur && r.onBlur(m), r.onFocusChange && r.onFocusChange(!1), e.setFocused(!1));
      }
    }),
    valueProps: {
      id: T
    },
    menuProps: {
      ...c,
      autoFocus: e.focusStrategy || !0,
      shouldSelectOnPressUp: !0,
      shouldFocusOnHover: !0,
      disallowEmptySelection: !0,
      onBlur: (m) => {
        m.currentTarget.contains(m.relatedTarget) || (r.onBlur && r.onBlur(m), r.onFocusChange && r.onFocusChange(!1), e.setFocused(!1));
      },
      "aria-labelledby": [
        b["aria-labelledby"],
        v["aria-label"] && !b["aria-labelledby"] ? v.id : null
      ].filter(Boolean).join(" ")
    },
    descriptionProps: y,
    errorMessageProps: p
  };
}
/*!
  MIT License

  Copyright (c) 2021 project44, Inc.

  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
  associated documentation files (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge, publish, distribute,
  sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all copies or substantial
  portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
  NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES
  OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
function mr(r) {
  const {
    defaultSelectedKeys: e = /* @__PURE__ */ new Set(),
    onSelectionChange: t,
    selectedKeys: n
  } = r, [i, s] = ue(
    n,
    e,
    t
  ), { collection: o, disabledKeys: u, selectionManager: c } = hr({
    ...r,
    allowDuplicateSelectionEvents: !0,
    selectionMode: "multiple",
    selectedKeys: i,
    onSelectionChange: (h) => {
      r.onSelectionChange && r.onSelectionChange(h), s(h);
    }
  }), f = i === "all" ? [...o] : [...i].map((h) => o.getItem(h));
  return {
    collection: o,
    disabledKeys: u,
    selectionManager: c,
    selectedKeys: i,
    setSelectedKeys: s.bind(c),
    selectedItems: f
  };
}
/*!
  MIT License

  Copyright (c) 2021 project44, Inc.

  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
  associated documentation files (the "Software"), to deal in the Software without restriction,
  including without limitation the rights to use, copy, modify, merge, publish, distribute,
  sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all copies or substantial
  portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
  NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
  NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES
  OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
function Er(r) {
  const [e, t] = Ee.useState(!1), n = br(r), i = mr(r);
  return {
    ...i,
    ...n,
    close() {
      n.close();
    },
    open() {
      i.collection.size > 0 && n.open();
    },
    toggle(s) {
      i.collection.size > 0 && n.toggle(s);
    },
    isFocused: e,
    setFocused: t
  };
}
export {
  pe as $,
  $r as H,
  Tt as _,
  Sr as a,
  Er as b,
  At as c,
  Ft as d,
  Yt as e,
  jt as f,
  Bt as g,
  qt as h,
  Lt as i,
  De as j,
  It as k,
  ue as l,
  vr as u
};
